import { API_BASE_URL } from '../config';
import type {
  AutocompleteResult,
  InterestOverTimeResult,
  RelatedQueriesResult,
} from '../types';

export async function fetchAutocomplete(
  keyword: string,
  locale: string,
  country: string,
  accessToken: string
): Promise<AutocompleteResult> {
  const params = new URLSearchParams({ q: keyword, locale, country });
  const response = await fetch(
    `${API_BASE_URL}/backoffice/meta/trends/autocomplete?${params.toString()}`,
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao buscar sugestões de autocomplete');
  }

  const payload = await response.json();
  return payload.data ?? payload;
}

export async function fetchInterestOverTime(
  keywords: string[],
  geo: string,
  timeframe: string,
  accessToken: string
): Promise<InterestOverTimeResult> {
  const params = new URLSearchParams({
    keywords: keywords.join(','),
    geo,
    timeframe,
  });
  const response = await fetch(
    `${API_BASE_URL}/backoffice/meta/trends/interest-over-time?${params.toString()}`,
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao buscar interesse ao longo do tempo');
  }

  const payload = await response.json();
  return payload.data ?? payload;
}

export async function fetchRelatedQueries(
  keyword: string,
  geo: string,
  timeframe: string,
  accessToken: string
): Promise<RelatedQueriesResult> {
  const params = new URLSearchParams({ q: keyword, geo, timeframe });
  const response = await fetch(
    `${API_BASE_URL}/backoffice/meta/trends/related-queries?${params.toString()}`,
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao buscar consultas relacionadas');
  }

  const payload = await response.json();
  return payload.data ?? payload;
}
